import { useState, useEffect } from "react";
import api from "../axiosInstance";

const useTotalInvestment = () => {
  const [totalInvestment, setTotalInvestment] = useState(0);
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const parent_id = sessionStorage.getItem("userid");

  useEffect(() => {
    if (!parent_id) return; // ✅ prevent API call if no user

    const fetchInvestment = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await api.get(`/dashboard/${parent_id}`);

        if (response.status === 200 && response.data?.success) {
          const data = response.data.data;

          // investment comes as string → parse to float
          const total = parseFloat(data.investment) || 0;

          setTotalInvestment(total);
          setDashboardData(data); // store full object (investment, client, reseller, product)
        } else {
          setDashboardData(null);
          setTotalInvestment(0);
        }
      } catch (err) {
        console.error("Error fetching investment:", err);
        setError("Failed to fetch investments");
      } finally {
        setLoading(false);
      }
    };

    fetchInvestment();
  }, [parent_id]);

  return { totalInvestment, dashboardData, loading, error };
};

export default useTotalInvestment;
